export class FakeBlob {
    constructor(buf, type) {
        this.buf = buf;
        this.type = type;
    }
}
